import { render } from "./Results.vue?vue&type=template&id=a1845914&bindings={\"score\":\"props\",\"rank\":\"data\"}"
import script from "./Results.vue?vue&type=script&lang=js"
export * from "./Results.vue?vue&type=script&lang=js"

import "./Results.vue?vue&type=style&index=0&lang=css"
script.render = render

export default script